import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';

import { configService } from 'services/config-service';

export default function initLogRocket() {
  if (process.env.NODE_ENV === 'production') {
    const logRocketAppId = configService
      .get('REACT_APP_LOGROCKET_APP_ID')
      .replace('-omega', '');
    LogRocket.init(logRocketAppId);
    setupLogRocketReact(LogRocket);
  }
}
